export interface IMetric {
  name: string;
  value: number;
  dimensions?: Record<string, string>;
}

export const DEFAULT_RESOURCE_TYPE = 'Unknown';
export const DEFAULT_RESOURCE_IDENTIFIER = 'N/A';
export const MICROSOFT_RESOURCE_ID_KEY = 'microsoft.resourceid';
export type ResourceType = typeof DEFAULT_RESOURCE_TYPE | 'Cameras';
export interface IArcMetricDimensions {
  ResourceType: ResourceType;
  ResourceIdentifier: string;
  [key: string]: string;
}

/**
 * User-provided metric dimensions that exclude reserved/required keys.
 * The keys 'ResourceType', 'ResourceIdentifier', and 'microsoft.resourceid' are managed internally
 * and cannot be overridden by users.
 */
export type IUserMetricDimensions = Omit<Record<string, string>, 'ResourceType' | 'ResourceIdentifier' | 'microsoft.resourceid'>;

export interface IArcMetric extends Omit<IMetric, 'dimensions'> {
  dimensions: IArcMetricDimensions;
}
